import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types
export interface Patient {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  date_of_birth: string;
  gender: string;
  address: string;
  blood_type: string;
  allergies: string;
  emergency_contact: string;
  insurance_provider: string;
  insurance_number: string;
  last_visit: string;
  status: string;
  created_at?: string;
  updated_at?: string;
}

export interface Medication {
  name: string;
  dosage: string;
  frequency: string;
  duration: string;
  instructions: string;
}

export interface Prescription {
  id: number;
  patient_id: number;
  doctor_name: string;
  medications: Medication[];
  diagnosis: string;
  notes: string;
  date: string;
  status: string;
  created_at?: string;
  updated_at?: string;
}

export interface ClinicUser {
  id: number;
  username: string;
  email: string;
  password_hash: string;
  role: 'admin' | 'doctor' | 'staff' | 'receptionist';
  permissions: string[];
  first_name: string;
  last_name: string;
  phone: string;
  is_active: boolean;
  last_login?: string;
  created_at?: string;
  updated_at?: string;
}